import { render, staticRenderFns } from "./OrticCheckboxControl.vue?vue&type=template&id=765d1cec"
import script from "./OrticCheckboxControl.vue?vue&type=script&lang=js"
export * from "./OrticCheckboxControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports